var loadMoreButtonEmployees = document.querySelectorAll('#loadMoreButtonEmployees');
if (loadMoreButtonEmployees && loadMoreButtonEmployees[0]) {
    loadMoreButtonEmployees[0].onclick = loadMoreEmployees;
}

var loadMoreButtonRmas = document.querySelectorAll('#loadMoreButtonRma');
if (loadMoreButtonRmas && loadMoreButtonRmas[0]) {
    loadMoreButtonRmas[0].onclick = loadMoreRma;
}

function loadMoreEmployees() {
    var el = this;

    var page = document.getElementById('employee-pagenumber');
    var organizationCode = document.getElementById('organizationCode');
    var searchTerm = document.getElementById('searchTerm');

    var target = document.getElementById("employeeContainer");
    var link = el.dataset.url;
    var employeeurl = el.dataset.employeeurl;

    page.textContent = +page.textContent + 1;

    window.fetch(link + '/LoadMore?page=' + page.textContent + "&organizationCode=" + organizationCode?.value + "&searchTerm=" + searchTerm.value + "&language=" + el.dataset.language + "&employeeUrl=" + employeeurl, {
        method: 'GET',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        },
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            target.innerHTML += html;

            window.reinit();

            //target.style.display = "table-cell";

            //if (el.querySelector('.order-row__wrapper--arrow')) {
            //    el.querySelector('.order-row__wrapper--arrow').classList.toggle('rotated');
            //}

            //initApproveBtns();
            //initDeclineBtns();
            //initDownloadBtn();

            //initCheckboxesForOrder(orderNumber);
            //initTextboxForOrderLineQuantity(orderNumber);
            //initReturnReasonDdl(orderNumber);
        })
        .catch(function (err) {
            console.log(err);
        });
}

function loadMoreRma() {
    var el = this;

    var page = document.getElementById('rma-pagenumber');
    var searchTerm = document.getElementById('searchTerm');

    var target = document.getElementById("rmaContainer");
    var link = el.dataset.url;
    var employeeurl = el.dataset.employeeurl;

    page.textContent = +page.textContent + 1;

    window.fetch(link + '/LoadMore?page=' + parseInt(page.textContent) + "&searchTerm=" + searchTerm.value + "&language=" + el.dataset.language + "&employeeurl=" + employeeurl, {
        method: 'GET',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        },
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            target.innerHTML += html;

            //target.style.display = "table-cell";

            //if (el.querySelector('.order-row__wrapper--arrow')) {
            //    el.querySelector('.order-row__wrapper--arrow').classList.toggle('rotated');
            //}

            //initApproveBtns();
            //initDeclineBtns();
            //initDownloadBtn();

            //initCheckboxesForOrder(orderNumber);
            //initTextboxForOrderLineQuantity(orderNumber);
            //initReturnReasonDdl(orderNumber);
        })
        .catch(function (err) {
            console.log(err);
        });
}